// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2s5eb","info":"PatientInfo_info__1LYQ6"};